document.addEventListener('DOMContentLoaded', function () {

  document.body.addEventListener('click', function (e) {
    const deviceBtn = e.target.closest('[data-property="device"] [data-value]');
    if (!deviceBtn) return;

    const deviceGroup = deviceBtn.closest('[data-property="device"]');
    if (!deviceGroup) return;

    // 1️⃣ VISUAL FIX – only one active device
    deviceGroup.querySelectorAll('[data-value]').forEach(btn => {
      btn.classList.remove('active');
      btn.setAttribute('aria-checked', 'false');
    });

    deviceBtn.classList.add('active');
    deviceBtn.setAttribute('aria-checked', 'true');

    // 2️⃣ SYNC WITH SHOPIFY VARIANT SELECT
    const selectedDevice = deviceBtn.getAttribute('data-value');
    const variantSelect = document.querySelector('select[data-js-product-variants]');
    if (!variantSelect) return;

    const matchingOption = Array.from(variantSelect.options).find(opt =>
      opt.text.includes(selectedDevice)
    );

    if (matchingOption) {
      variantSelect.value = matchingOption.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

});
